import { render, staticRenderFns } from "./VuexTable.vue?vue&type=template&id=d3160490&"
import script from "./VuexTable.vue?vue&type=script&lang=js&"
export * from "./VuexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports